import { call } from '@/lib/api';

import { TContact } from '@/models/contacts';
import { Paper, Table, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useLocation } from 'wouter';
import Loader from '../Loader';
type Company = {
  id: string;
  name: string;
  column_values: {
    text: string | null;
    value: string | null;
    column: {
      title: string;
    };
  }[];
};

const flatten = (companies: Company[]) =>
  companies.reduce<{ [key: string]: string }[]>((out, c) => {
    const o = {
      name: c.name,
      ...c.column_values.reduce(
        (o, cv) => ({ ...o, [cv.column.title]: cv.text }),
        {},
      ),
      id: c.id,
    };
    out.push(o);
    return out;
  }, []);

export default function Companies({ contact }: { contact: TContact }) {
  const [loading, setLoading] = useState(true);
  const [_, nav] = useLocation();
  const [companies, setCompanies] = useState<Company[]>([]);
  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;
    call<Company[]>('contact/companies', {
      json: { pulseId: contact.id },
      signal,
    })
      .then((res) => res.json())
      .then(setCompanies)
      .catch((e) => {
        if (e !== 'normal') throw e;
      })
      .finally(() => {
        setLoading(false);
      });
    return () => {
      controller.abort('normal');
    };
  }, [contact.id]);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Paper shadow="xs" my="md" maw={960}>
        <Table highlightOnHover horizontalSpacing="md" verticalSpacing="md">
          <Table.Thead>
            <Table.Tr>
              <Table.Th style={{ whiteSpace: 'nowrap' }}>Name</Table.Th>
              <Table.Th style={{ whiteSpace: 'nowrap' }}>
                Date of Incorporation
              </Table.Th>
              <Table.Th style={{ whiteSpace: 'nowrap' }}>
                Full Company Name
              </Table.Th>
              <Table.Th style={{ whiteSpace: 'nowrap' }}>
                Company Registration Number
              </Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {flatten(companies).map((c, i) => (
              <Table.Tr key={i} onClick={() => nav(`~/companies/${c.id}`)}>
                {Object.values(c)
                  .slice(0, 4)
                  .map((v, i) => (
                    <Table.Td key={i}>
                      {i === 0 ? (
                        <Text td="underline" style={{ cursor: 'pointer' }}>
                          {v}
                        </Text>
                      ) : (
                        v
                      )}
                    </Table.Td>
                  ))}
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Paper>
    </>
  );
}
